module.exports = __webpack_public_path__ + "img/logo_przedruk-1.fab4ab97.png";